import { Helper } from "./helper";

export class VersionChecker
{
    private static lastCheckTime: number;
    private static version: string;

    static async loadInitialVersion()
    {
        try
        {
            this.version = (await fetch("/", { method: "HEAD" })).headers.get("ETag");
        }
        catch
        {
            this.version = "AskingVersionError";
        }
        this.lastCheckTime = Date.now();
    }

    static async checkAndRefreshIfNeeded()
    {
        const currentTime: number = Date.now();
        // Check version if last check time is older than 2 minutes
        if ((currentTime - this.lastCheckTime) > 120 * 1000)
        {
            let newVersion: string;
            try
            {
                newVersion = (await fetch("/", { method: "HEAD" })).headers.get("ETag");
            }
            catch
            {
                return;
            }
            if (newVersion !== this.version)
            {
                Helper.refreshPage();
            }
            this.lastCheckTime = currentTime;
        }
    }
}
